import { FC, SubmitEvent, useState } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { houseToHouseServices } from 'src/services';
import { HTHForm } from './commons/HTHForm';
import { typeObservation, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser } from 'src/custom-hooks';

type propsType = {
    closeShowFormHandler: () => void;
    currentFace: typeHTHFace;
    editText: string;
    idEdit: number;
    territoryNumber: typeTerritoryNumber;
};

export const HTHObservationsForm: FC<propsType> = ({ closeShowFormHandler, currentFace, editText, idEdit, territoryNumber }) => {
    const [text, setText] = useState<string>(editText);
    const date = generalHelpers.GetCurrentLocalDate();
    const dispatch = useDispatch();
    const user = useGetCurrentUser();
    
    const submitHandler = async (e: SubmitEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        if (!text || !text.trim() || !user) {
            return;
        }
        const newObservation: typeObservation = {
            creatorId: user.id,
            date,
            id: idEdit ? idEdit : Date.now(),
            text: text.trim()
        };
        if (!editText) {
            dispatch(showLoadingModalReducer());
            const response = await houseToHouseServices.AddObservation(territoryNumber, currentFace.block, currentFace.face, currentFace.id, newObservation);
            dispatch(hideLoadingModalReducer());
            if (!response.success) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            closeShowFormHandler();
            setText('');
        } else {
            dispatch(showLoadingModalReducer());
            const response = await houseToHouseServices.EditObservation(territoryNumber, currentFace.block, currentFace.face, newObservation);
            dispatch(hideLoadingModalReducer());
            if (!response.success) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            closeShowFormHandler();
            setText('');
        }
    }

    const cancelFormHandler = (): void => {
        closeShowFormHandler();
        setText('');
    }

    const setTextHandler = (_text: string): void => setText(_text);

    return (
        <HTHForm
            cancelFormHandler={cancelFormHandler}
            currentFace={currentFace}
            date={date}
            isDoNotCallForm={false}
            submitHandler={submitHandler}
            territoryNumber={territoryNumber}
            text={text}
            setTextHandler={setTextHandler}
        />
    );
}
